// import "./GemstonesSection.css";

// import { useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Navigation } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";

// import gemstonesData from "../../data/gemstonesData";
// import ProductCard from "../RudrakshaSection/ProductCard";

// const banners = [
//   "https://i.pinimg.com/1200x/6e/e6/11/6ee61157ebd5b676bcb8fe3f63833ee2.jpg",
//   "https://i.pinimg.com/736x/77/2b/89/772b89a2dddd5274343bba2466418090.jpg",
//   "https://i.pinimg.com/736x/48/c1/d9/48c1d9815f1a6180e789a9ace3128f87.jpg",
// ];

// export default function GemstonesSection() {
//   const tabs = Object.keys(gemstonesData);

//   const [activeTab, setActiveTab] = useState(tabs[0]);

//   return (
//     <section className="gemstones-section">
//       <div className="container">
//         <div className="section-top">
//           <h2>Buy 100% Original Gemstones</h2>

//           <div className="tabs">
//             {tabs.map((tab) => (
//               <button
//                 key={tab}
//                 className={activeTab === tab ? "active" : ""}
//                 onClick={() => setActiveTab(tab)}
//               >
//                 {tab}
//               </button>
//             ))}
//           </div>
//         </div>

//         <div className="section-content">
//           <div className="left-banner">
//             <Swiper
//               modules={[Autoplay]}
//               autoplay={{
//                 delay: 3000,
//                 disableOnInteraction: false,
//               }}
//               loop
//             >
//               {banners.map((image, index) => (
//                 <SwiperSlide key={index}>
//                   <img src={image} alt="" />
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           </div>

//           <div className="right-products">
//             {/* <Swiper
//               modules={[Navigation, Autoplay]}
//               navigation
//               loop
//               autoplay={{
//                 delay: 3500,
//                 disableOnInteraction: false,
//               }}
//               slidesPerView={3}
//               spaceBetween={20}
//               breakpoints={{
//                 0: {
//                   slidesPerView: 1,
//                 },
//                 768: {
//                   slidesPerView: 2,
//                 },
//                 1200: {
//                   slidesPerView: 3,
//                 },
//               }}
//             > */}
//             <Swiper
//               modules={[Navigation, Autoplay]}
//               navigation
//               loop={true}
//               spaceBetween={10}
//               slidesPerView={3}
//               breakpoints={{
//                 0: {
//                   slidesPerView: 2,
//                   spaceBetween: 10,
//                 },
//                 576: {
//                   slidesPerView: 2,
//                   spaceBetween: 12,
//                 },
//                 768: {
//                   slidesPerView: 2,
//                   spaceBetween: 15,
//                 },
//                 1200: {
//                   slidesPerView: 3,
//                   spaceBetween: 20,
//                 },
//               }}
//             >
//               {gemstonesData[activeTab].map((product) => (
//                 <SwiperSlide key={product.id}>
//                   <ProductCard product={product} />
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }



// api integrate
import "./GemstonesSection.css";

import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import ProductCard from "../RudrakshaSection/ProductCard";
import Loader from "../Loader/Loader";
import { getProducts } from "../../api/productApi";
import { getCategories } from "../../api/getCategories";

// =====================================================
// GEMSTONE CATEGORY SLUG
// =====================================================

const GEMSTONE_CATEGORY_SLUG = "gemstones";

// =====================================================
// BANNERS
// =====================================================

const banners = [
  "https://i.pinimg.com/1200x/6e/e6/11/6ee61157ebd5b676bcb8fe3f63833ee2.jpg",
  "https://i.pinimg.com/736x/77/2b/89/772b89a2dddd5274343bba2466418090.jpg",
  "https://i.pinimg.com/736x/48/c1/d9/48c1d9815f1a6180e789a9ace3128f87.jpg",
];

export default function GemstonesSection() {

  // ===================================================
  // STATES
  // ===================================================

  const [gemstoneCategory, setGemstoneCategory] =
    useState(null);

  const [subcategories, setSubcategories] = useState([]);

  const [activeSubcategory, setActiveSubcategory] =
    useState(null);

  const [products, setProducts] = useState([]);

  const [loadingCategories, setLoadingCategories] =
    useState(true);

  const [loadingProducts, setLoadingProducts] =
    useState(false);

  // ===================================================
  // GET GEMSTONE CATEGORY + SUBCATEGORIES
  // Same /categories source and order as the shop page.
  // ===================================================

  useEffect(() => {

    const fetchGemstoneCategory = async () => {

      try {

        setLoadingCategories(true);

        const result = await getCategories();

        const gemstones = (result?.data || []).find(
          (category) =>
            category?.slug?.toLowerCase() ===
            GEMSTONE_CATEGORY_SLUG
        );

        if (!result?.success || !gemstones) {

          console.error("Gemstones category not found");

          setGemstoneCategory(null);
          setSubcategories([]);

          return;

        }

        setGemstoneCategory(gemstones);

        setSubcategories(gemstones.subcategories || []);

      } catch (error) {

        console.error(
          "Gemstone Category API Error:",
          error
        );

        setGemstoneCategory(null);
        setSubcategories([]);

      } finally {

        setLoadingCategories(false);

      }

    };

    fetchGemstoneCategory();

  }, []);

  // ===================================================
  // GET ALL GEMSTONE PRODUCTS
  // ===================================================

  const fetchAllProducts = async (categoryId) => {

    try {

      if (!categoryId) return;

      setLoadingProducts(true);

      const result = await getProducts({

        categoryId,

        page: 1,

        limit: 12,

      });

      console.log(
        "All Gemstone Products:",
        result
      );

      if (result?.success) {

        setProducts(
          result?.data?.products || []
        );

      } else {

        setProducts([]);

      }

    } catch (error) {

      console.error(
        "Gemstone Products API Error:",
        error
      );

      setProducts([]);

    } finally {

      setLoadingProducts(false);

    }

  };

  // ===================================================
  // GET PRODUCTS BY SUBCATEGORY
  // ===================================================

  const fetchProductsBySubcategory = async (
    subcategoryId
  ) => {

    try {

      if (!gemstoneCategory?.id || !subcategoryId) return;

      setLoadingProducts(true);

      const result = await getProducts({

        categoryId: gemstoneCategory.id,

        subcategoryId: subcategoryId,

        page: 1,

        limit: 12,

      });

      console.log(
        "Products By Subcategory:",
        result
      );

      if (result?.success) {

        setProducts(
          result?.data?.products || []
        );

      } else {

        setProducts([]);

      }

    } catch (error) {

      console.error(
        "Subcategory Products API Error:",
        error
      );

      setProducts([]);

    } finally {

      setLoadingProducts(false);

    }

  };

  // ===================================================
  // INITIAL PRODUCTS
  // ===================================================

  useEffect(() => {

    if (gemstoneCategory?.id) {

      setActiveSubcategory(null);

      fetchAllProducts(gemstoneCategory.id);

    }

  }, [gemstoneCategory]);

  // ===================================================
  // TAB CLICK
  // ===================================================

  const handleSubcategoryClick = (
    subcategory
  ) => {

    setActiveSubcategory(
      subcategory?.id
    );

    fetchProductsBySubcategory(
      subcategory.id
    );

  };

  // ===================================================
  // ALL GEMSTONES CLICK
  // ===================================================

  const handleAllClick = () => {

    if (!gemstoneCategory?.id) return;

    setActiveSubcategory(null);

    fetchAllProducts(gemstoneCategory.id);

  };

  // ===================================================
  // IMAGE URL
  // ===================================================

  return (

    <section className="gemstones-section">

      <div className="container">

        {/* =================================================
            TOP
        ================================================= */}

        <div className="section-top">

          <h2>
            Buy 100% Original Gemstones
          </h2>

          {/* =================================================
              TABS
          ================================================= */}

          <div className="tabs">

            {/* ALL GEMSTONES */}

            <button
              type="button"
              className={
                activeSubcategory === null
                  ? "active"
                  : ""
              }
              onClick={handleAllClick}
            >
              All Gemstones
            </button>


            {/* API SUBCATEGORIES */}

            {!loadingCategories &&
              subcategories.map(
                (subcategory) => (

                  <button
                    type="button"
                    key={subcategory.id}
                    className={
                      activeSubcategory ===
                      subcategory.id
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleSubcategoryClick(
                        subcategory
                      )
                    }
                  >
                    {subcategory.name}
                  </button>

                )
              )}

          </div>

        </div>


        {/* =================================================
            CONTENT
        ================================================= */}

        <div className="section-content">


          {/* =================================================
              LEFT BANNER
          ================================================= */}

          <div className="left-banner">

            <Swiper
              modules={[Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop
            >

              {banners.map(
                (image, index) => (

                  <SwiperSlide
                    key={index}
                  >

                    <img
                      src={image}
                      alt="Gemstones"
                    />

                  </SwiperSlide>

                )
              )}

            </Swiper>

          </div>


          {/* =================================================
              RIGHT PRODUCTS
          ================================================= */}

          <div className="right-products">

            {/* LOADING */}

            {loadingCategories || loadingProducts ? (

              <div className="loading">

                <Loader label="Loading gemstones..." size={56} />

              </div>

            ) : products.length === 0 ? (

              /* NO PRODUCTS */

              <div className="loading">

                No gemstones found

              </div>

            ) : (

              <Swiper

                modules={[
                  Navigation,
                  Autoplay,
                ]}

                navigation

                loop={
                  products.length > 3
                }

                spaceBetween={10}

                slidesPerView={3}

                breakpoints={{

                  0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },

                  576: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                  },

                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },

                }}
              >

                {products.map(
                  (product) => (

                    <SwiperSlide
                      key={product.id}
                    >

                      <ProductCard
                        product={product}
                      />

                    </SwiperSlide>

                  )
                )}

              </Swiper>

            )}

          </div>

        </div>

      </div>

    </section>

  );

}